module.exports = __webpack_public_path__ + "img/about_pic5.d2991569.png";